
<f-dialog
    v-model       = "show"
    :width        = "550"
    :show-header  = "true"
    :hide-actions = "false"
    :inset        = "true"
    content-class = "dialog-border"
    :title        = "$t('disposition.report.title')"
    :show-save    = "false"
    :show-delete  = "false"
    :show-cancel  = "false"
    @cancel       = "onCancel"
>
    <template v-slot:preaction>
        <div class="v-flex w-100 mr-2">
            <v-spacer />
            <div class = "download-label">
                {{ $t('disposition.report.create.date') + ":" }}
            </div>
            <div class="download-date-select">
                <v-select
                    class   = "pt-0 create-date-entry"
                    v-model = "dates.download.selected"
                    :items  = "dates.download.items"
                    hide-details
                >
                    <template v-slot:item="{ item }">
                        {{ formatDate(item) }}
                    </template>
                    <template v-slot:selection="{ item }">
                        {{ formatDate(item) }}
                    </template>
                </v-select>
            </div>

            <v-btn
                :disabled = "!dates.download.selected || createReports"
                class     = "dialog-button primary"
                @click    = "onExport"
                depressed
            >
                Download
            </v-btn>
        </div>
    </template>
    <template v-slot:content>
        <div class="mode-radio-group">
            <div style="position: absolute; right: 0; top: 36px;z-index: 100">
                <v-checkbox
                    v-model = "recalculate"
                    :label  = "$t('audit.rebuild.label')"
                    :ripple = "false"
                    class   = "pt-0 mt-0"

                    hide-details
                />
            </div>
            <v-radio-group v-model="createMode" hide-details>
                <v-radio
                    :label="$t('disposition.report.create.mode.allDocuments')"
                    value="allDocuments"
                />
                <v-radio
                    :label="$t('disposition.report.create.mode.newDocuments')"
                    value="newDocuments"
                />
                <v-radio
                    :label="$t('disposition.report.create.mode.currentDocuments')"
                    value="currentDocuments"
                />
                <v-radio
                    v-if="dates.created.items.length > 0"
                    :label="$t('disposition.report.create.mode.dateDocuments')"
                    value="dateDocuments"
                />
            </v-radio-group>

            <div
                v-if  ="dates.created.items.length > 0 && createMode === 'dateDocuments'"
                class = "create-date-select"
            >
                <v-select
                    v-model = "dates.created.selected"
                    :items  = "dates.created.items"
                    :label  = "$t('disposition.report.create.mode.allDocuments')"
                    @input  = "onCreateDate"
                    hide-details
                >
                    <template v-slot:item="{ item }">
                        {{ formatDate(item) }}
                    </template>
                    <template v-slot:selection="{ item }">
                        {{ formatDate(item) }}
                    </template>
                </v-select>
            </div>

            <div class="create-button">
                <v-btn
                    :disabled = "!createMode || createReports"
                    class     = "dialog-button primary"
                    @click    = "onPrint"
                    depressed
                >
                    {{ $t("disposition.report.create.button") }}
                </v-btn>
            </div>
        </div>

        <v-divider class="mt-2 mb-3" />

        <v-progress-linear
            v-model = "done.percentage"
            color   = "primary"
            :height = "20"

            rounded
        >
            <div
                v-if  = "inspections.display"
                class = "progress-label"
            >
                {{ done.count }} / {{ inspections.display.length }}
            </div>

        </v-progress-linear>
        <c-card-iterator
            v-if               = "inspections.display"
            :items             = "inspections.display"
            :item-gap          = "0"
            :filter-height     = "0"
            :height            = "400"
            :item-height       = "50"
            key-field          = "id"
            :zoom              = "false"
            :left-arrow        = "false"
            :refresh-on-filter = "false"
            :show-count        = "false"
            :enable-search     = "false"
            :show-title        = false
            scroller-type      = "default"
            ref                = "iterator"
        >
            <template v-slot:card="{ item }">
                <p-inspection-report-card
                    :inspection = "item.data"
                    @print      = "onPrintSingle"
                />
                <v-divider class="mt-2" />
            </template>
        </c-card-iterator>
    </template>
</f-dialog>
